import { setter } from './utils';
import { SET_CLIENT_SIZE } from '../actions/types';

export default setter(SET_CLIENT_SIZE, { width: 0, height: 0 });
